import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SeguridadService } from "@servicios/Seguridad.service";
import {ColaboradorComponent } from "./colaborador/colaborador.component";
import {ConfiguracionComponent } from "./configuracion/configuracion.component";
import { EjecucionEvaluacionComponent } from "./ejecucionevaluacion/ejecucionevaluacion.component";
import { AdministracionAcuerdoComponent } from "./administracionacuerdo/administracionacuerdo.component";



const routes: Routes = [
    {path: '', redirectTo: 'colaborador', pathMatch: 'full'},
    {path: 'colaborador', component: ColaboradorComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
    {path: 'configuracion', component: ConfiguracionComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
    {path: 'configevaluacion', component: EjecucionEvaluacionComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
    {path: 'configacuerdo', component: AdministracionAcuerdoComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class EvaluacionesPendientesRoutingModule {}
